import { parseJSONSafe } from '@velasca/utils/parse-json-safe'
import type { AboutUsPageProps } from './AboutUsPage.types'

export const getAboutUsPageData = (): Pick<AboutUsPageProps, 'rows'> => {
  const blocksDataEl = document.querySelector<HTMLElement>(
    '#aboutus-blocks-data',
  )

  if (!blocksDataEl) {
    return { rows: [] }
  }

  const blocksData = parseJSONSafe(blocksDataEl.innerHTML, {
    fallbackValue: { rows: [] },
  }) as Pick<AboutUsPageProps, 'rows'>

  return blocksData
}
